export const dateRangeTexts = {
  picker: {
    header: {
      notes: 'Header for date range picker',
      message: 'Set time range',
    },
    custom: {
      notes: 'Header when no preset is selected in date range picker',
      message: 'Custom',
    },
    fields: {
      from: {
        label: {
          notes: 'Label for from field in date range picker',
          message: 'From',
        },
      },
      to: {
        label: {
          notes: 'Label for to field in date range picker',
          message: 'To',
        },
      },
    },
    timeZoneHint: {
      viewingInTimeZone: {
        notes:
          'Help text showing which timezone dates are displayed in, e.g. "Viewing times in UTC+2"',
        message: 'Viewing times in UTC{{offset}}',
      },
      youAreIn: {
        notes:
          'Help text showing the user\'s own timezone offset, e.g. "You are in UTC+1"',
        message: 'You are in UTC{{offset}}',
      },
    },
    actions: {
      cancel: {
        label: {
          notes: 'Cancel action for date range picker',
          message: 'Cancel',
        },
      },
      set: {
        label: {
          notes: 'Set action for date range picker',
          message: 'Set',
        },
      },
    },
  },
  presets: {
    header: {
      notes: 'Subheader for date range presets',
      message: 'Presets',
    },
    lastXHours: {
      label: {
        notes: 'Label for last X hours preset in date range controls',
        message: 'Last {{numberOfHours}} hours',
      },
    },
    lastXDays: {
      label: {
        notes: 'Label for last X days preset in date range controls',
        message: 'Last {{numberOfDays}} days',
      },
    },
    today: {
      label: {
        notes: 'Label for today preset in date range controls',
        message: 'Today',
      },
    },
    yesterday: {
      label: {
        notes: 'Label for yesterday preset in date range controls',
        message: 'Yesterday',
      },
    },
    week: {
      label: {
        notes: 'Label for this week preset in date range controls',
        message: 'This week',
      },
    },
    previousWeek: {
      label: {
        notes: 'Label for previous week preset in date range controls',
        message: 'Previous week',
      },
    },
    month: {
      label: {
        notes: 'Label for this month preset in date range controls',
        message: 'This month',
      },
    },
    previousMonth: {
      label: {
        notes: 'Label for previous month preset in date range controls',
        message: 'Previous month',
      },
    },
    year: {
      label: {
        notes: 'Label for this year preset in date range controls',
        message: 'This year',
      },
    },
    previousYear: {
      label: {
        notes: 'Label for previous year preset in date range controls',
        message: 'Previous year',
      },
    },
  },
  steppers: {
    previous: {
      label: {
        notes: 'Previous action for date range step controls',
        message: 'Previous',
      },
    },
    next: {
      label: {
        notes: 'Next action for date range step controls',
        message: 'Next',
      },
    },
  },
} as const;
